import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";
import {MassWarningTemplate} from "../typedefs";
import {useQuery} from "react-query";
import {useAuth} from "../../../context/user";
import useDebouncer from "../../../hooks/debouncer";

export function useGetMassWarningTemplates(type: string, clientID: string | null) {
    return useCallback(async (search: string, page: number): Promise<PaginatedResponseV2<MassWarningTemplate> | null> => {
        const res = await platformAPI.get<PaginatedResponseV2<MassWarningTemplate>>("api/siren/templates", {
            params: {page, limit: 20, search, type, ...(clientID ? {clientID} : {})}
        })
        const {results, hasMore, currentPage} = res.data
        return {results, hasMore, currentPage}
    }, [clientID, type])
}

export function useGetMassWarningTemplateOptions(clientID: string | null) {
    const [search, setSearch] = useState("");
    const debouncedSearch = useDebouncer(search, 300);
    const auth = useAuth();

    const {data, isLoading, refetch} = useQuery(
        ["mass-warning-template-options", clientID, debouncedSearch],
        async () => {
            const res = await platformAPI.get<PaginatedResponseV2<MassWarningTemplate>>("api/siren/templates", {
                params: {page: 1, limit: 100, search: debouncedSearch, ...(clientID ? {clientID} : {})}
            })
            return res.data
        },
        {enabled: !!clientID || !auth.isSuperAdmin, cacheTime: 0}
    );

    return {data, isLoading, search, setSearch, refetch}
}